<template>
  <form class="login-form" v-on:submit.prevent="">
    <vue-loading :active.sync="isAuthenticating" :can-cancel="false" :is-full-page="false"></vue-loading>
    <div class="form-group response-message" v-if="responseMessage != ''">
      <span v-bind:class="{ 'error-message': hasError }">{{ responseMessage }}</span>
    </div>
    <div class="form-group">
      <input
        type="text"
        class="form-control"
        placeholder="Enter email"
        autocomplete="username"
        v-model="user_name"
      >
    </div>
    <div class="form-group" v-if="!isForgotPassword">
      <input
        type="password"
        class="form-control"
        placeholder="Password"
        autocomplete="current-password"
        v-model="password"
      >
    </div>
    <div class="form-row align-items-center" v-if="!isForgotPassword">
      <div class="col-8">
        <a
          href="javascript:void(0)"
          v-on:click="isForgotPassword = !isForgotPassword"
        >Forgot Password?</a>
      </div>
      <div class="col-4">
        <button class="btn btn-block btn-sm btn-primary" @click="login">Login</button>
      </div>
    </div>
    <div class="form-row align-items-center" v-if="isForgotPassword">
      <div class="col-8">
        <a href="javascript:void(0)" v-on:click="isForgotPassword = !isForgotPassword">Back to login</a>
      </div>
      <div class="col-4">
        <button class="btn btn-block btn-sm btn-primary" @click="forgot">Send</button>
      </div>
    </div>
  </form>
</template>

<script>
import store from "@/store";
import { USER_LOGIN, USER_FORGOT_PASSWORD, USER_CLEAR_MESSAGE } from "@/store/actions.type";

export default {
  name: "vue-login",
  components: {},
  props: ["username", "redirect"],
  data: function() {
    return {      
      user_name: "",
      password: "",
      isForgotPassword: false
    };
  },
  mounted() {
    var self = this;
    self.user_name = self.username || self.user_name;
  },
  computed: {
    isAuthenticating() {      
      return store.state.user.is_authenticating;
    },
    responseMessage() {
      return store.state.user.message;
    },
    hasError() {
      return store.state.user.has_error;
    }
  },
  watch: {
    isForgotPassword: function(newValue) {
      var self = this;
      self.$log.debug("Forgot Password Changed", newValue);
      store.dispatch(USER_CLEAR_MESSAGE);
      self.$emit("forgotPasswordChangedEvent");
    },
  },
  methods: {
    login: function() {
      var self = this;
      self.$log.debug("Login Request");
      store.dispatch(USER_LOGIN, {
        username: self.user_name,
        password: self.password,
        redirect: self.redirect
      });
    },
    forgot: function(){
      var self = this;
      self.$log.debug("Forgot Password Request");
      store.dispatch(USER_FORGOT_PASSWORD, {
        username: self.user_name
      });
    }
  }
};
</script>


<style lang="scss">
 .response-message {
   span {
      font-size: 0.75rem;
      font-weight: 700;
      text-transform:none;
      text-align: justify;
   }   
 }
</style>